import styled from "styled-components";
import {Col as AntdCol, Layout} from "antd";
import {Button as StyledButton, Button2} from "../../../styles/buttons";

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const Button = styled(Button2)`
  width: unset;
  margin-top: 0;
  margin-left: 10px;
  align-self: flex-end;
  border-radius: 20px;
`;

export const Form = styled.form``;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Col = styled(AntdCol)`
  width: 12.4rem;
  margin-bottom: 0.8rem;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px                                                                           ;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

    &:focus, &:hover {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 768px) {
    min-width: 0em;
  }
`;

export const ValueCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  div {
    text-align: center;
    margin-right: 20px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: white;
    padding: 10px;
    height: 90px;
    width: 160px;
    border: 1px solid rgba(92, 92, 92, 0.22);
    box-shadow: 1px 2px 9px rgba(92, 92, 92, 0.55);
  }

  @media (max-width: 940px) {
    flex-wrap: wrap;
    height: auto;
    align-content: space-around;
    justify-content: center;

    div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      margin-right: 4px;
    }
  }
`;

export const TableContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
    }

  .ant-pagination-item,
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
    display: none;
  }
`;